import _ from 'lodash';
import React, { createContext, useReducer, useState } from 'react';
import Reducer from './Reducer';
import Authentication from '../controllers/authentication';
import Country from '../controllers/country';
import navbarData from '../data/navbar'
import countries from '../data/localisation/countries'
import languages from '../data/localisation/languages'

const globalState = {
    auth: new Authentication(),
    locale: new Country(countries,languages),
    menu: navbarData
}
globalState.menu.push(globalState.locale.getCompiledLocaleMenuItem());
globalState.authenticated = !!globalState.auth ? globalState.auth.isAuthenticated() : false;

const GlobalContextComponent = ({children}) => {
  const [state, dispatch] = useAsyncReducer(Reducer, globalState);

  return(
      <GlobalContext.Provider value={[ state, dispatch ]}>
          {children}
      </GlobalContext.Provider>
  )
};

const useAsyncReducer = (reducer, initialState = null) => {
    const [state, setState] = useState(initialState);

    const dispatch = async action => {
        const result = reducer(state, action);
        if (typeof result.then === "function") {
            try {
                const newState = await result;
                setState(newState);
            } catch (err) {
                setState({ ...state, error: err });
            }
        } else {
            setState(result);
        }

    };

    return [state, dispatch];
};

export const GlobalContext = createContext(globalState);
export default GlobalContextComponent;